import * as React from 'react';
import { FormFeedback, FormGroup, Input, Label, Table } from 'reactstrap';

import Localization from '../../config/localization';

import Notifications from '../../lib/notifications';
import { DateStringToMinValue, ToFloat, ToString } from '../../lib/utils';

import CloseSvg from '../Svg/close';
import PenSvg from '../Svg/pen';

import './Computation.scss';

class Computation extends React.Component<Computation.IProps, Computation.IState> {
  static defaultProps = {
    approvedAmountLabel: Localization.backOfficeComputationAddTabelAprovedAmount,
    effectiveAmountLabel: Localization.backOfficeComputationAddTabelEffectiveAmount
  };
  state = { wasEdited: false, startDate: false, endDate: false, price: false };

  componentDidUpdate(prevState: Readonly<Computation.IProps>) {
    if (prevState.endDate !== undefined && this.props.endDate === undefined) {
      this.setState({ wasEdited: false, startDate: false, endDate: false, price: false }, () => this.forceUpdate());
    }
  }

  renderAidRow = (aid: Aid.IGetAidForBackOffice) => {
    if (!aid) {
      return null;
    }

    aid.consumption = aid.consumption === '' ? '' : ToFloat(aid.consumption);

    return (
      <tr key={aid.personalIdentificationNumber} className="text-center">
        <td>{ToString(aid.name)}</td>
        <td>{aid.personalIdentificationNumber}</td>
        <td
          className="strong">{this._countAidValues(aid).map((value, index) => `${ToString(index && '/')}${value}`)}</td>
        <td className="remove-arrow position-relative">
          {(this._showEditData() && (
            <Input
              type="number"
              name={ToString(aid.personalIdentificationNumber)}
              id="consumption"
              step="0.01"
              min={0}
              value={aid.consumption}
              onChange={this._setConsumption}
              onFocus={() => this._onFocus(aid)}
              onBlur={() => this._onBlur(aid)}
              className="eon-input-text consumption text-center p-0"
              invalid={!this._aidValidation(aid) && (!aid.focus && this.state.wasEdited)}
            />
          )) ||
          aid.consumption}
        </td>
        <td className="strong">{this._countEfectiveQuantum(aid)}</td>
      </tr>
    );
  };

  render() {
    return (
      <React.Fragment>
        <div className="mt-4 d-flex">
          <FormGroup className="w-25 pl-2 remove-arrow mr-5">
            <Label className="text-nowrap" for="startDate">
              {Localization.backOfficeComputationAddFrom}
            </Label>
            <Input
              type="date"
              name="startDate"
              id="startDate"
              disabled={!this._showEditData()}
              min={this.props.min}
              max={this.props.endDate || this.props.max}
              value={this.props.startDate}
              onChange={this._setValue}
              className={`eon-input-text position-relative calendar-field ${
                !this.props.startDate && this.state.startDate ? 'is-field-error' : ''
              } `}
              invalid={!this.props.startDate && this.state.startDate}
            />
            <FormFeedback tooltip>{Localization.beneficiaryAddApprovalDocumentDataError}</FormFeedback>
          </FormGroup>

          <FormGroup className="w-25 pl-2 remove-arrow">
            <Label className="text-nowrap" for="endDate">
              {Localization.backOfficeComputationAddTo}
            </Label>
            <Input
              type="date"
              name="endDate"
              id="endDate"
              disabled={!this._showEditData()}
              min={this.props.startDate ? DateStringToMinValue(this.props.startDate) : this.props.min}
              max={this.props.max}
              value={this.props.endDate || ''}
              onChange={this._setValue}
              className={`eon-input-text position-relative calendar-field ${
                !this.props.endDate && this.props.endDate !== undefined && this.state.endDate ? 'is-field-error' : ''
              } `}
              invalid={!this.props.endDate && this.props.endDate !== undefined && this.state.endDate}
            />
            <FormFeedback tooltip>{Localization.beneficiaryAddApprovalDocumentDataError}</FormFeedback>
          </FormGroup>
        </div>

        <FormGroup className="w-25 pl-2 remove-arrow">
          <Label className="text-nowrap" for="price">
            {Localization.backOfficeComputationAddPrice}
          </Label>
          <Input
            type="number"
            name="price"
            id="price"
            disabled={!this._showEditData()}
            value={this.props.price}
            onChange={this._setValue}
            className={`eon-input-text ${!this.props.price && this.state.price ? 'is-field-error' : ''} `}
            invalid={!this.props.price && this.state.price}
          />
          <FormFeedback tooltip>{Localization.beneficiaryAddApprovalDocumentDataError}</FormFeedback>
        </FormGroup>

        {this.props.aids && (
          <Table size="sm" className="m-0 mt-5">
            <thead>
            <tr className="text-uppercase eon-red text-center">
              <th className="strong">{Localization.backOfficeComputationAddTabelBeneficiary}</th>
              <th className="strong">{Localization.backOfficeComputationAddTabelCNP}</th>
              <th className="strong">{this.props.approvedAmountLabel}</th>
              <th className="strong">{Localization.backOfficeComputationAddTabelConsumption}</th>
              <th className="strong">{this.props.effectiveAmountLabel}</th>
            </tr>
            </thead>
            <tbody>{this.props.aids.map(aid => this.renderAidRow(aid))}</tbody>
            <tfoot>
            <tr className="bg-eon-ultra-light-grey text-center">
              <td />
              <td />
              <td className="strong">{this._countTotal()}</td>
              <td className="strong">
                {this.props.aids && ToFloat(this.props.aids.map(aid => ToFloat(aid.consumption)).reduce((a, b) => a + b, 0))}
              </td>
              <td className="strong">
                {this.props.aids &&
                ToFloat(this.props.aids.map(aid => this._countEfectiveQuantum(aid)).reduce((a, b) => ToFloat(a) + ToFloat(b), 0))}
              </td>
            </tr>
            </tfoot>
          </Table>
        )}

        <div className={`btn-container d-flex mt-4 pr-5 ${this.props.isEdit ? 'mb-5' : ''}`}>
          {this._showEditData() && (
            <React.Fragment>
              <button
                className="eon-button bg-eon-red eon-white ml-auto mr-5"
                disabled={this._disableSave()}
                onClick={this.props.CreateInterval}
              >
                <span className="px-3">{Localization.backOfficeComputationAddSave}</span>
              </button>
              {this.props.isEdit && (
                <a className="eon-middle-grey mx-4 align-self-center c-pointer" onClick={this.props.OnClose}>
                  <CloseSvg className="m-auto align-baseline" />
                  <span className="px-1 text-nowrap">{Localization.backOfficeComputationAddCancel}</span>
                </a>
              )}
            </React.Fragment>
          )}

          {this.props.isEdit && !this.props.editData && (
            <a className="ml-auto mr-5 link-color c-pointer-no-color d-flex" onClick={this.props.SetEdit}>
              <span className="px-1 text-nowrap">{Localization.backOfficeComputationAddEdit}</span>
              <PenSvg className="m-auto" />
            </a>
          )}
        </div>
      </React.Fragment>
    );
  }

  _countTotal = () => {
    if (!this.props.aids) {
      return 0;
    }
    return [0].concat(...this.props.aids.map(aid => this._countAidValues(aid))).reduce((a, b) => a + b, 0);
  };

  _showEditData = () => !this.props.isEdit || !(this.props.isEdit && !this.props.editData);

  _countAidValues = (aid: Aid.IGetAidForBackOffice) => {
    return (aid.aidsValues && aid.aidsValues.split('/').map(aidsValues => ToFloat(aidsValues))) || [0];
  };

  _countEfectiveQuantum = (aid: Aid.IGetAidForBackOffice) => {
    if (aid.cuantumValues === undefined || aid.cuantumValues === null) {
      return null;
    }

    return (
      (aid.cuantumValues &&
        aid.cuantumValues
          .split('/')
          .map(cuantumValues => ToFloat(cuantumValues))
          .reduce((a, b) => a + b, 0)) ||
      0
    );
  };

  _onFocus = (aid: Aid.IGetAidForBackOffice) => {
    aid.focus = true;
    this.setState({ wasEdited: true });

    return this.forceUpdate();
  };

  _onBlur = (aid: Aid.IGetAidForBackOffice) => {
    aid.focus = false;
    this.setState({ wasEdited: true });

    return this._calculate(aid);
  };

  _aidValidation = (aid: Aid.IGetAidForBackOffice) => {
    return !!aid.consumption || aid.consumption === 0;
  };

  _disableSave = () => {
    if (!this.props.startDate) {
      return true;
    } else if (!this.props.endDate) {
      return true;
    } else if (!this.props.price) {
      return true;
    } else if (!this.props.aids || !this.props.aids.length) {
      return true;
    }

    return !!this.props.aids.find(aid => !this._aidValidation(aid));
  };

  _setConsumption = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ wasEdited: true });

    return this.props.SetConsumption(event);
  };

  _setValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const element = event.currentTarget || event.target || {};

    this.setState(prevState => ({ ...prevState, [element.id]: true }));

    return this.props.SetValue(event);
  };

  _calculate = async (aid: Aid.IGetAidForBackOffice) => {
    try {
      const response = await this.props.api({
        consumption: ToFloat(aid.consumption),
        consumptionPoint: ToString(aid.consumptionPoint),
        endDate: ToString(this.props.endDate),
        personalIdentificationNumber: aid.personalIdentificationNumber,
        startDate: ToString(this.props.startDate)
      });

      aid.cuantumValues = response.data && response.data.cuantumValues;

      return this.forceUpdate();
    } catch (error) {
      Notifications.error(error && error.message);

      return this.forceUpdate();
    }
  };
}

export default Computation;
